$select-check-dropDown-background1:'#182A38' !default;
$select-check-dropDown-background2:'#2A475B' !default;
$selected-option-background1: '#192533' !default;

.multi-select-checkbox-dropdown {
  .multi-select-checkbox-btn {
    background: linear-gradient(0deg, #{$select-check-dropDown-background1}, #{$select-check-dropDown-background2}) !important;
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/multi-select/multi-select-theme.scss